import { render, staticRenderFns } from "./OtherIncomeModule.vue?vue&type=template&id=6543bec9"
import script from "./OtherIncomeModule.vue?vue&type=script&lang=js"
export * from "./OtherIncomeModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports